<template>
    <div class="com-partm7 flex justify-center align-center">
        <div
            v-for="(item, i) in config"
            :key="'config' + i"
            class="flex item-box align-center">
            <div class="item-label flex align-center justify-center">{{ item.label }}</div>
            <div class="flex align-center flex1">
                <div
                    v-for="(data, x) in item.data"
                    :key="'item.data' + x"
                    class="flex align-center justify-center flex1">
                    <img v-if="item.type == 1" class="item-icon" :src="data.icon" alt="" />
                    <span v-else
                        :class="{'item-icon1': item.type == 2, 'item-icon2': item.type == 3}"
                        :style="{'background': data.color}"></span>
                    <div class="item-text">{{ data.label }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            config: [
                {
                    label: '显存负载',
                    type: 1,
                    data: [
                        {
                            icon: require('@/assets/images/computility/monitor-icon10.png'),
                            label: '显存负载0~50%'
                        },
                        {
                            icon: require('@/assets/images/computility/monitor-icon11.png'),
                            label: '显存负载50%~80%'
                        },
                        {
                            icon: require('@/assets/images/computility/monitor-icon12.png'),
                            label: '显存负载80%以上'
                        }
                    ]
                },
                {
                    label: 'GPU温度',
                    type: 2,
                    data: [
                        {
                            color: '#6DBF87',
                            label: '温度0°C~70°C­'
                        },
                        {
                            color: '#E5750D',
                            label: '温度70°C~90°C­'
                        },
                        {
                            color: '#FF0606',
                            label: '温度90°C以上­'
                        }
                    ]
                },
                {
                    label: '服务器状态',
                    type: 3,
                    data: [
                        {
                            color: '#979797',
                            label: '服务器关机'
                        },
                        {
                            color: '#5BCF41',
                            label: '服务器正常运行'
                        },
                        {
                            color: '#E5750D',
                            label: '服务器告警'
                        }
                    ]
                }
            ]
        }
    },
	mounted() {
    },
	methods: {
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm7 {
    width: 100%;
    height: 170px;
    font-size: $FontSize18;
    .item-box {
        width: 880px;
        height: 60px;
        border: 1px dashed #00BABA;
        margin: 0 120px;
        .item-label {
            background-color: #2CADAD66;
            height: 100%;
            width: 118px;
            font-size: $FontSize20;
        }
        .item-icon,  .item-icon1, .item-icon2 {
            margin-right: 20px;
        }
        .item-icon {
            height: 20px;
        }
        .item-icon1 {
            width: 20px;
            height: 20px;
            border-radius: 10px;
        }
        .item-icon2 {
            width: 40px;
            height: 20px;
            border-radius: 10px;
        }
        .item-text {
            white-space: nowrap;
        }
    }
}
</style>